import { v4 as id } from 'uuid';

export const createId = () => id();
